import React, { useState, useEffect, useRef } from 'react';
// SKIP_PREFLIGHT_CHECK=true
import { withStyles } from '@material-ui/core/styles';
import { withAuth } from '@okta/okta-react';
import { useLocation } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DragDrop from '../../Common/Component/Js/DragAndDrop';
import './dropzone.css';
/* import {
  BarLoader
} from 'react-spinners'; */

import Table from '../../Common/Component/Js/Table';
import appConstants from '../../Common/Assets/appConstants';
import queryString from 'query-string';
import $ from 'jquery';
import FileViewer from '../../Common/Component/Js/FilePreview/components/file-viewer';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import util from '../../Common/Assets/util';

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: 30
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  icon: {
    margin: theme.spacing(2),
  }
});

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Same text as the API's LastModified ("%b %d, %Y %I:%M:%S %p %Z" in UTC).
function formatLastModified(date) {
  const pad = n => String(n).padStart(2, '0');
  const hours = date.getUTCHours();
  return `${MONTHS[date.getUTCMonth()]} ${pad(date.getUTCDate())}, ${date.getUTCFullYear()} ` +
    `${pad(hours % 12 || 12)}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())} ${hours < 12 ? 'AM' : 'PM'} UTC`;
}

// Same text as the API's convert_size (api/utils.py), e.g. "1.0 KB", "2.35 MB".
function convertSize(size) {
  if (size === 0) return '0B';
  const sizeNames = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(size) / Math.log(1024));
  const s = Math.round((size / Math.pow(1024, i)) * 100) / 100;
  return `${Number.isInteger(s) ? s.toFixed(1) : s} ${sizeNames[i]}`;
}

// Table rows in the same shape as the list_bucket API returns.
function uploadedFileRow(key, name, size, date) {
  return {
    Key: key, Name: name, is_folder: false, Size: String(size), ConvertedSize: convertSize(size),
    StorageClass: 'Standard', LastModified: formatLastModified(date), LastModifiedTs: Math.floor(date.getTime() / 1000)
  };
}

function folderRow(key, name) {
  return { Key: key, Name: name, is_folder: true, Size: '--', ConvertedSize: '--', StorageClass: '--', LastModified: '--', LastModifiedTs: 0 };
}

function S3File(props) {
  const location = useLocation();
  const paramConst = queryString.parse(location.search)
  const [data, setData] = useState([]);
  const [bucket, setBucket] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [paramValues, setparamValues] = useState(paramConst);
  const [folderName, setFolderName] = useState(() => {
    if (!paramConst.folder)
      return ' ';
    else
      return paramConst.folder;
  });
  const [orgBucketName, setOrgBucketName] = useState('');
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState();
  const [bucketid, setBucketid] = useState(paramConst.bucketid);
  const [columns, setColumns] = useState(appConstants.folderColumns);
  const [api, setApi] = useState(props.api);
  const [searchVal, setSearchVal] = useState();
  const [modelOpen, setModelOpen] = useState(false);
  const [preview, setPreview] = useState({});
  const [uploadView, setUploadView] = useState(false);
  // True while the API has more pages of this folder to load (S3 returns at most 1000 entries per page).
  const [hasMore, setHasMore] = useState(false);
  const loadingMoreRef = useRef(false);
  const currentLocationRef = useRef('');
  currentLocationRef.current = `${orgBucketName}|${folderName}`;
  //api.glacierFileInfo = {};


  async function initializeData() {
    try {
      setNextToken('');
      let paramValues = queryString.parse(location.search);
      let folders;
      if (paramValues.FA === 0 || paramValues.FA === '0') api.fullaccess = false;
      if (paramValues.DA === false || paramValues.DA === 'false') api.folderAccess = false;
      (folderName && folderName === ' ') ? setTitle(paramValues.bucket) :
        setTitle(folderName.split('/')[folderName.split('/').length - 1]);
      const bucket = await api.getBucketWithId(bucketid);
      var bucketData = await bucket;
      setBucket(bucketData);
      api.folderDelete = bucketData.enable_delete;
      if (api.fullaccess || paramValues.folder) {
        setColumns(appConstants.folderColumns);
        folders = await api.getFolderNew(folderName, bucketData.name, '');
      }
      else {
        setColumns(appConstants.restrictedAccessFolders);
        folders = await api.getBucket(bucketid);
      }
      const folderData = await folders;
      api.region = folderData.region
      if (!(props.api.fullaccess || paramValues.folder)) {
        folderData.map((x) => {
          x.is_folder = true;
          x['Name'] = x.name;
        });
        setData(folderData);
        setNextToken('');
      } else {
        setData(folderData.objects);
        setNextToken(folderData.next_token);
      }
      if (bucket)
        setOrgBucketName(bucket.name);
      if (paramValues.search) setSearchVal(paramValues.search);
      // Modify Bucket Name to its alias, if it exists.
      if (bucketData.alias)
        bucketData.name = bucketData.alias
      setTableLoading(false);
      clearSelectionofRows();
    }
    catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    initializeData();
    return () => {
    };
  }, [folderName])

  useEffect(() => {
    setTableLoading(true);
    let paramValues = queryString.parse(location.search);
    setparamValues(paramValues);
    setFolderName(() => {
      if (!paramValues.folder)
        return ' ';
      else
        return paramValues.folder;
    });
    setBucketid(paramValues.bucketid);
    return () => {
    };
  }, [useLocation().search])

  function clearSelectionofRows() {
    props.api.selectedRows = [];
    util.setSelectedRows([]);
    // setSelectedRows([]);
  }
  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose(event) {
    if (event.target.innerText === 'YES') {
      downloadGlacierFile()
    }
    setOpen(false);
  }

  function handleRowClicked(event, rowData) {
    event.preventDefault();
    // if (event.target.type === "checkbox") {
    if (/checkbox/.test(event.target.outerHTML)) {
      return;
    } else if (rowData['bucket']) {
      var folder = rowData.Name.replace(/\//g, '%2F');
      api.folderAccess = rowData.user_permission === 'FullAccess' ? true : false;
      api.folderDelete = rowData.enable_delete;
      props.history.push(`${props.location.pathname}?bucketid=${bucket.id}&bucket=${bucket.name}&folder=${folder}&FA=0${paramValues.DA ? `&DA=${api.folderAccess}` : ``}`)
    } else {
      let folArray = rowData.Key.split('/').filter((x) => x !== '');

      var folder1 = folArray.join('/').replace(/\//g, '%2F').replace(/&/g, '%26').replace(/\+/g, '%2B')
      if (rowData.is_folder) {
        api.nextToken = '';
        setSearchVal('');
        props.history.push(`${props.location.pathname}?bucketid=${bucket.id}&bucket=${bucket.name}` +
          `&folder=${folder1}&FA=${paramValues.FA ? paramValues.FA : 1}${paramValues.DA ? `&DA=${paramValues.DA}` : ``}`)
      } else if (rowData.StorageClass === 'Glacier' || rowData.StorageClass === 'Deep_Archive') {
        api.glacierFileInfo = { 'key': rowData.Key, 'name': rowData.Name };
        handleClickOpen();
      } else {
        api.getDownloadURL(orgBucketName, rowData.Key.replace(/\//g, '%2F').replace(/\+/g, '%2B').replace(/&/g, '%26'),props.api.region).then((res) => {
          let fileName = rowData.Name.split('.');
          let fileType = fileName[fileName.length - 1];
          let acceptedFileTypes = ['csv', 'jpg', 'jpeg', 'gif', 'bmp', 'png', 'PNG', 'pdf', 'mp3', 'mp4', 'webm', 'mov', 'wav', 'xlsx', 'xls', 'docx', 'doc'];  //,'avi', 'wmv' 
          if (acceptedFileTypes.indexOf(fileType.toLowerCase()) > -1) {
            setPreview({ type: fileType, path: res });
            setModelOpen(true);
          } else {
            window.open(res);
          }
        });
      }
    }
  }

  // Keep the API's next_token (URL-encoded, ready for the next request) and whether more pages exist.
  function setNextToken(token) {
    // trim(): older API versions returned " " when there were no more pages.
    const nextToken = (token || '').trim();
    api.nextToken = encodeURIComponent(nextToken);
    setHasMore(nextToken !== '');
  }

  function rowsChange(pageSize) {
    getDataOnPaginate(1, pageSize);
  }
  // Load the next page from the API once the user reaches the second-to-last loaded table page.
  async function getDataOnPaginate(page, pageSize) {
    if (!api.nextToken || loadingMoreRef.current) return;
    if (data.length - page * pageSize > pageSize) return;
    const requestedLocation = currentLocationRef.current;
    loadingMoreRef.current = true;
    try {
      const folderData = await api.getFolderNew(folderName, orgBucketName, api.nextToken);
      if (currentLocationRef.current !== requestedLocation) return;
      setData(prevData => [...prevData, ...folderData.objects]);
      setNextToken(folderData.next_token);
    } catch (error) {
      console.log(error);
      sendTostMessage('Failed to load more files. Please try again.', 'error');
    } finally {
      loadingMoreRef.current = false;
    }
  }

  // The refresh only returns the first page, so add rows for just-uploaded files that S3 lists on a later page.
  function withUploadedFiles(rows, uploadedFiles) {
    if (!uploadedFiles || uploadedFiles.length === 0) return rows;
    const prefix = folderName === ' ' ? '' : `${folderName}/`;
    const keys = new Set(rows.map(row => row.Key));
    const now = new Date();
    const uploadedRows = [];
    uploadedFiles.forEach(file => {
      const [name, ...rest] = file.filePath.split('/');
      // A file inside a dropped folder shows up as that folder at this level.
      const row = rest.length === 0 ? uploadedFileRow(prefix + name, name, file.size, now) : folderRow(`${prefix}${name}/`, name);
      if (!keys.has(row.Key)) {
        keys.add(row.Key);
        uploadedRows.push(row);
      }
    });
    return [...rows, ...uploadedRows];
  }
  function sendTostMessage(msg, success) {
    if (success === "success") {
      props.toast.success(msg, {
        position: props.toast.POSITION.TOP_CENTER
      });
    } else {
      props.toast.error(msg, {
        position: props.toast.POSITION.TOP_CENTER
      });
    }
  }

  function refreshData(acceptedFiles, uploadedFiles) {
    setTableLoading(true);
    $(window).unbind('beforeunload');
    const requestedLocation = `${orgBucketName}|${folderName}`;
    api.getFolderNew(folderName, orgBucketName, '')
      .then((resp) => {
        // Ignore the response if the user has moved to another bucket/folder meanwhile.
        if (currentLocationRef.current !== requestedLocation) return;
        // Start again from the first page; later pages load as the user pages through the table.
        setData(withUploadedFiles(resp.objects, uploadedFiles));
        setNextToken(resp.next_token);
        (acceptedFiles) && sendTostMessage(`${acceptedFiles}`, 'success');
        setTableLoading(false);
      })
      .catch((error) => {
        console.log(error);
        if (currentLocationRef.current !== requestedLocation) return;
        sendTostMessage('Failed to refresh the file list. Please reload the page.', 'error');
        setTableLoading(false);
      });
  }

  function refreshDataCallback(error) {
    $(window).unbind('beforeunload');
    props.toast.error(error.message, {
      position: props.toast.POSITION.TOP_CENTER
    });
  }

  function downloadGlacierFile() {
    new Promise(resolve => {
      // setTimeout(() => {
      let bucketname = orgBucketName;
      let fileKey = api.glacierFileInfo.key;
      let fileName = api.glacierFileInfo.name;
      api.restoreGlacierFile(bucketname, fileKey, fileName, props.api.region).then(
        resp => {
          if (resp.restore_status === 'submitted') {
            props.toast.success(`Restore process request has been submitted.You will get an email notification,once file is available to download`, {
              position: props.toast.POSITION.TOP_CENTER
            });
          } else if (resp.restore_status === 'completed') {
            window.open(resp.downloadUrl)
          } else {
            props.toast.success(`Restore is in process.You will get an email notification,once file is available to download`, {
              position: props.toast.POSITION.TOP_CENTER
            });
          }
        });
      resolve();
      // }, 600);
    })
  }
  function handleModelClose() {
    setModelOpen(false);
    setUploadView(false)
    setPreview({});
  }
  function handleUpload() {
    setUploadView(true);
    setModelOpen(true);
  }
  function handleUploadClose() {
    // No refresh here: the upload window already refreshes the list when a batch finishes.
    $(window).unbind('beforeunload')
    setModelOpen(false);
    setUploadView(false)
    setPreview({});
  }

  return (
    <div className={styles.root}>

      {modelOpen ? <Modal
        open={modelOpen}
        onClose={handleModelClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        disableBackdropClick={uploadView}
        disableEscapeKeyDown={uploadView}
      >
        {modelOpen && preview.type ? <div className="modelMain">
          <FileViewer
            fileType={preview.type}
            filePath={preview.path}
          />
        </div> : (modelOpen && uploadView && orgBucketName !== '') ? <div className="modelMain">
          <div><CloseIcon className="dragdrop-close" onClick={handleUploadClose} fontSize="small" /></div>
          <DragDrop sendTostMessage={sendTostMessage}
            folderName={folderName} bucket={orgBucketName} bucketid={bucketid} {...props}
            refreshData={refreshData} refreshDataCallback={refreshDataCallback} />
          {/* <div className="dragdrop-end">.</div> */}
        </div> : ''}

      </Modal> : ''}
      {/* {modelOpen ? <Modal
        open={modelOpen}
        onClose={handleModelClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {modelOpen && preview.type ? <div className="modelMain">
          <FileViewer
            fileType={preview.type}
            filePath={preview.path}
          />
        </div> : ''}

      </Modal> : ''} */}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This file is stored in glacier.  Are you sure you want to retrieve it and download?  Click ‘YES’ to continue.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Yes
            </Button>
          <Button onClick={handleClose} color="primary">
            No
            </Button>
        </DialogActions>
      </Dialog>

      {/* {(((api.fullaccess || paramValues.folder) && api.folderAccess) && orgBucketName !== '') ?
        <DragDrop sendTostMessage={sendTostMessage} folderName={folderName} bucket={orgBucketName}
          bucketid={bucketid} {...props} sendTostMessage={sendTostMessage}
          refreshData={refreshData} refreshDataCallback={refreshDataCallback} />
        : <div style={{ 'marginBlockEnd': '0.5em' }} />} */}
      <div style={{ 'marginBlockEnd': '0.5em' }} />
      <Table tableLoading={tableLoading} orgBucketName={orgBucketName} paginationChange={getDataOnPaginate}
        handleRowClicked={handleRowClicked} rowsChange={rowsChange}
        title={title} {...props} tableData={data} columns={columns} name={folderName} bucketid={bucketid}
        bucket={bucket} refreshData={refreshData} sendTostMessage={sendTostMessage} searchVal={searchVal} hasMore={hasMore}
        handleClickOpen={handleClickOpen} handleUpload={handleUpload} deleteAccess={api.folderDelete} uploadAccess={((api.fullaccess || paramValues.folder) && api.folderAccess)} />
    </div>
  );
}

export default withStyles(styles)(withAuth(S3File));
